// extracted by mini-css-extract-plugin
export var connectionButton = "_bn-1";
export var connectionButtonFloating = "_bn-2";
export var connectionContainer = "_bn-0";
export var rightPanel = "_bn-6";
export var stepCard = "_bn-3";
export var stepCardSubtitle = "_bn-5";
export var stepCardText = "_bn-4";